import { render, staticRenderFns } from "./AffaireTypes.vue?vue&type=template&id=84120a10&"
import script from "./AffaireTypes.vue?vue&type=script&lang=js&"
export * from "./AffaireTypes.vue?vue&type=script&lang=js&"
import style0 from "./AffaireTypes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports